import { render } from "./SchedaVisualizzazioneHelp.vue?vue&type=template&id=07c8d409"
import script from "./SchedaVisualizzazioneHelp.vue?vue&type=script&lang=js"
export * from "./SchedaVisualizzazioneHelp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__